import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import PropTypes from "prop-types";
import { equals } from "ramda";
import { MainText } from "@base-ui";
import { StyledAccordion, HeaderContainer, ContentContainer, styledSystemKeys } from "./accordion.styles";
import { useOpen, useCustomEffect } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Accordion = function Accordion(props) {
  var id = props.id,
    title = props.title,
    header = props.header,
    _open = props._open,
    notifyOpen = props.notifyOpen,
    icon = props.icon,
    _ref = props._ref,
    className = props.className,
    background = props.background,
    limitedHeight = props.limitedHeight,
    minHeight = props.minHeight,
    padding = props.padding,
    borderTop = props.borderTop,
    borderBottom = props.borderBottom;
  var _useOpen = useOpen(_open),
    open = _useOpen.open,
    toggleOpen = _useOpen.toggleOpen;
  useCustomEffect(function () {
    if (notifyOpen) notifyOpen(open);
  }, [open]);
  return /*#__PURE__*/_jsxs(StyledAccordion, _objectSpread(_objectSpread({}, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    ref: _ref || undefined,
    borderBottom: borderBottom,
    className: "accordion-container ".concat(className || ""),
    children: [/*#__PURE__*/_jsx(MainText, {
      as: header || "h2",
      style: {
        margin: 0,
        fontFamily: "Roboto-Regular"
      },
      children: /*#__PURE__*/_jsx(HeaderContainer, {
        id: id,
        className: "accordion-expander",
        "aria-controls": "".concat(id, "-section"),
        "aria-expanded": open,
        "data-component": "accordion",
        icon: icon,
        open: open,
        onClick: toggleOpen,
        background: background,
        minHeight: minHeight,
        borderTop: borderTop,
        padding: padding,
        children: title
      })
    }), /*#__PURE__*/_jsx(ContentContainer, {
      id: "".concat(id, "-section"),
      open: open,
      className: "accordion-content-container",
      limitedHeight: limitedHeight,
      background: background,
      padding: padding,
      children: /*#__PURE__*/_jsx("div", {
        style: {
          display: open ? "block" : "none",
          paddingTop: open ? "10px" : 0
        },
        className: "accordion-visibility-container",
        children: props.children
      })
    })]
  }));
};
Accordion.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  notifyOpen: PropTypes.func,
  header: PropTypes.oneOf(["h2", "h3", "h4"]),
  _open: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.string,
  limitedHeight: PropTypes.bool,
  minHeight: PropTypes.string,
  padding: PropTypes.string,
  borderTop: PropTypes.string,
  borderBottom: PropTypes.bool
};
Accordion.defaultProps = {
  _open: false,
  header: "h2",
  borderBottom: true
};
export default /*#__PURE__*/memo(Accordion, function (prev, curr) {
  return equals(prev.children, curr.children, prev._open, curr._open);
});